<script setup>
import { computed } from "vue";
import AppIcon from "./AppIcon.vue";
import { ref, reactive } from "vue";

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});

let tempVal = "";
let tempAdd = "";
let filterStr = reactive({
  str: "",
});

function addEnum(variable) {
  if (tempVal.length == 0) return;
  variable.enumValues.push(tempVal);
  tempVal = "";
}

function addVariable() {
  props.data[tempAdd] = {
    type: "int",
    enumValues: [],
    value: 0,
  };
  tempAdd = "";
}

function popEnum(indx, variable) {
  variable.enumValues.splice(indx, 1);
}

function updateFilter() {}

const filteredData = computed(() => {
  return Object.entries(props.data)
    .filter(([key, value]) =>
      key.toLowerCase().includes(filterStr["str"].toLowerCase())
    )
    .reduce((obj, [key, value]) => {
      obj[key] = value;
      return obj;
    }, {});
});

const types = ["string", "int", "float", "enum"];

const emit = defineEmits(["close-win"]);
</script>

<template>
  <div class="basic-window" v-if="data">
    <div class="ui-container">
      <div class="win-header">
        <h3>Variables</h3>
        <div class="cornerbutton add">
          <button
            @click="$emit('close-win')"
            title="Close"
            class="ui-button ui-button-blue ui-button-medium"
          >
            <AppIcon name="xmark" />
          </button>
        </div>
        <div class="row">
          <div class="ui-controls">
            <div class="ui-form-textinput">
              <div class="ui-label">Add new</div>
              <input
                type="text"
                v-model="tempAdd"
                v-on:keyup.enter="addVariable()"
              />
            </div>
          </div>
          <div class="ui-controls">
            <div class="ui-form-textinput">
              <div class="ui-label">Filter</div>
              <input type="text" v-model="filterStr['str']" />
            </div>
          </div>
        </div>
      </div>
      <div class="win-scrollpane">
        <div class="ui-sub-container">
          <div
            v-bind:key="index"
            v-for="(variable, index) in filteredData"
            class="ui-controls vars"
          >
            <h4>{{ index }}</h4>
            <div class="bg-vars">
              <div class="row">
                <div class="column-20">
                  <div class="ui-form-textinput">
                    <div class="ui-label">Type</div>
                    <select v-model="variable.type" class="ui-select">
                      <option
                        v-bind:key="ind"
                        v-for="(type, ind) in types"
                        :value="type"
                      >
                        {{ type }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="column-20">
                  <div class="ui-form-textinput">
                    <div class="ui-label">Default</div>
                    <div v-if="variable.type != 'enum'">
                      <input v-model="variable.value" />
                    </div>
                    <div v-if="variable.type == 'enum'">
                      <select v-model="variable.value" class="ui-select">
                        <option
                          v-bind:key="index"
                          v-for="(vari, index) in variable.enumValues"
                          :value="vari"
                        >
                          {{ vari }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="column-60">
                  <div v-if="variable.type == 'enum'" class="ui-form-textinput">
                    <div class="ui-label">Enum types</div>
                    <div>
                      <div
                        @click="popEnum(indx, variable)"
                        class="enumtag"
                        v-bind:key="indx"
                        v-for="(enumval, indx) in variable.enumValues"
                      >
                        {{ enumval }}
                      </div>
                      <input
                        style="
                          display: inline-block;
                          width: 80px;
                          margin-left: 6px;
                        "
                        type="text"
                        v-model="tempVal"
                        v-on:keyup.enter="addEnum(variable)"
                      />
                    </div>
                  </div>

                  <div
                    v-if="variable.type == 'number'"
                    class="ui-form-textinput"
                  >
                    <div class="ui-label">Number bounds</div>
                    <input
                      style="
                        display: inline-block;
                        width: 80px;
                        margin-left: 6px;
                      "
                      type="text"
                    />
                    <input
                      style="
                        display: inline-block;
                        width: 80px;
                        margin-left: 6px;
                      "
                      type="text"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

